(() => {
  'use strict';

  const launchTime = (value, timeZone) => {
    if (!timeZone) return /(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ? Date.parse(value) : NaN;
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):00$/.exec(value);
    if (!match) return NaN;
    const [year, month, day, hour, minute] = match.slice(1).map(Number);
    if (year < 2000 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59) return NaN;
    const wallTime = Date.UTC(year, month - 1, day, hour, minute);
    const calendar = new Date(wallTime);
    if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) return NaN;
    try {
      const formatter = new Intl.DateTimeFormat('en-GB', {timeZone, year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23'});
      const localWallTime = (timestamp) => {
        const parts = Object.fromEntries(formatter.formatToParts(timestamp).map(part => [part.type, part.value]));
        return Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
      };
      let instant = wallTime;
      for (let i = 0; i < 4; i++) {
        const difference = wallTime - localWallTime(instant);
        if (difference === 0) return instant;
        instant += difference;
      }
      // A nonexistent local time during a daylight-saving transition stays hidden.
      return localWallTime(instant) === wallTime ? instant : NaN;
    } catch {
      return NaN;
    }
  };

  class WaitlistCountdown extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      // The editor uses a simple date and time; Vienna's DST is resolved here.
      const iso = this.dataset.date || '';
      this.targetTime = launchTime(iso, this.dataset.timezone);
      this.endNote = this.parentElement.querySelector('[data-launch-ended]');
      this.hidden = true;
      if (this.endNote) this.endNote.hidden = true;
      if (!Number.isFinite(this.targetTime)) return;
      if (this.update()) this.timer = setInterval(() => this.update(), 1000);
    }

    update() {
      const remaining = Math.max(0, Math.ceil((this.targetTime - Date.now()) / 1000));
      if (remaining === 0) {
        this.hidden = true;
        if (this.endNote) this.endNote.hidden = false;
        clearInterval(this.timer);
        return false;
      }
      const units = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining % 86400 / 3600),
        minutes: Math.floor(remaining % 3600 / 60),
        seconds: remaining % 60
      };
      for (const [unit, value] of Object.entries(units)) {
        const node = this.querySelector(`[data-unit="${unit}"]`);
        if (node) node.textContent = String(value).padStart(2, '0');
      }
      this.hidden = false;
      return true;
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('waitlist-countdown')) customElements.define('waitlist-countdown', WaitlistCountdown);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-policy-target]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    const dialog = document.getElementById(link.dataset.policyTarget);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      dialog.showModal();
    }
  });

  // Success and error states are rendered only by Shopify after native submission.
  // Forms deliberately keep native POST, validation and Shopify spam protection.
  const focusMessage = (scope) => {
    const message = scope.querySelector('[data-form-message]');
    if (message) message.focus();
  };
  focusMessage(document);
  document.addEventListener('shopify:section:load', (event) => focusMessage(event.target));
})();
